import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiButton from "@mui/material/Button";
import { TrackNowButton } from "../ui";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import Input from "@mui/material/Input";
import ListItemText from "@mui/material/ListItemText";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import { IconButton, Tooltip } from "@mui/material";
import { DateTime } from "luxon";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import FileDownload from "js-file-download";

import {
  Card,
  CardActions,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import type {
  FilingMasterWorkflow,
  FilingMasterWorkflowComment,
} from "../../types/FilingMaster";
import axios from "axios";
import useDialog from "../common/UseDialog";
import CloseIcon from "@mui/icons-material/Close";
import { TrackNowTextField } from "../ui/TrackNowTextField";
;
;
;


type Anchor = "top" | "left" | "bottom" | "right";
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

export default function FilingMasterWorkflowComments(props: {
  dockAt?: "top" | "left" | "bottom" | "right";
  show?: boolean;
  handleClose: () => void;
  rowData?: FilingMasterWorkflow;
  workflow?: FilingMasterWorkflow;
  comments?: FilingMasterWorkflowComment[];
  refreshList: () => void;
  value: any;
}) {
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    getFilingMasterWorkflowComments,
    addFilingMasterWorkflowComment,
    getFilingMasterWorkflowCommentsAttachments,
  } = filingMasterContext;
  const formRef = useRef<HTMLFormElement>(null);
  const [data, setData] = React.useState<FilingMasterWorkflowComment[]>([]);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const authContext = useContext(AuthContext);
  const { authUser, userRoles, toLocalDateTime, roleType } = authContext;
  const [alertMessage, setAlertMessage] = useState("");
  const [approvalComment, setApprovalComment] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [remainingChars, setRemainingChars] = useState(256);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedComment, setSelectedComment] = useState<any>({});
  const [actionType, setActionType] = useState<any>("Add");
  // const [isPopUpVisible, setIsPopUpVisible] = useState(false);

  // function handleCloseClick() {

  //       setIsPopUpVisible(false);

  //     }

  const closeAlert = () => {
    setShowAlert(false);
    props.handleClose();
    // navigate("/filing-master-approval-list");
  };

  const onFileChange = async (event: any) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const footerContent = (
    <div>
      <Button
        label="OK"
        icon="pi pi-check"
        onClick={() => closeAlert()}
        autoFocus
      />
    </div>
  );

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        // // console.log(`Drawer Mouse Key Event...`);
        // if (
        //   event.type === "keydown" &&
        //   ((event as React.KeyboardEvent).key === "Tab" ||
        //     (event as React.KeyboardEvent).key === "Shift")
        // ) {
        //   return;
        // }
        // // console.log(`Toogle Drawer: DockAt:${anchor}, Show: ${open}`);
        // setState({ ...state, [anchor]: open });
        // if (!open) props.handleClose();
      };
  const toLocalTime = (date: Date): string => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy hh:mm:ss");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };
  useEffect(() => {
    setLoading(true);

    if (
      typeof props.dockAt !== "undefined" &&
      typeof props.show !== "undefined"
    ) {
      // console.log(
      //   `Toogle Drawer UEF: DockAt:${props.dockAt}, Show: ${props.show}`
      // );
      // toggleDrawer(props.dockAt, props.show);
      if (props.show) {
        setState({ ...state, [props.dockAt]: props.show });
        setActionType("Add")
      }
    }

    setApprovalComment((old) => "");

    if (
      (getFilingMasterWorkflowComments &&
        props.workflow &&
        props.workflow.workflowId) ||
      (getFilingMasterWorkflowComments &&
        props.rowData &&
        props.rowData.workflowId)
    ) {
      // console.log(`Fetching Commnet for :${props.workflow?.workflowId}`);
      // console.log(`Fetching Commnet for rowdata :${props.rowData?.workflowId}`);
      //   fetchFilingMasterComments(props.workflow.workflowId);
    }
    console.log("PROPS CHECK", "value", props.value, "Workflow", props.workflow, "RowData", props.rowData);
    //eslint-disable-next-line
  }, [props.show]);

  const fetchCommentsAttachments = async (data: any = null) => {
    data = data ? data : props.comments;
    let attachments = await getFilingMasterWorkflowCommentsAttachments?.();
    // console.log("Fetched attachments", attachments);
    let comments =
      data &&
      data.map((comment: any) => {
        const matchingAttachment = attachments.filter(
          (attachment: any) => attachment.commentsId === comment.commentsId
        );
        if (matchingAttachment.length > 0) {
          const { attachmentId, attachmentPath } = matchingAttachment[0];
          return { ...comment, attachmentId, attachmentPath };
        }
        return comment;
      });
    // console.log("Attachments", comments);
    comments && setData(comments);
  };

  useEffect(() => {
    if (props.show) {
      const _data: FilingMasterWorkflowComment[] = props.comments!;
      setLoading(true);

      if (props.comments) {
        try {
          setData(() => _data);
        } finally {
          setLoading(false);
        }
      }
      fetchCommentsAttachments();
    }

    //eslint-disable-next-line
  }, [props.comments]);

  //   useEffect(() => {
  //     // if(props.workflow && props.workflow.createDate!==null)
  //     //eslint-disable-next-line
  //   }, [props.workflow]);

  //   const fetchFilingMasterComments = async (filingId: number) => {
  // //     console.log("@@Fetch FilingMasters1:", getFilingMasterWorkflowComments);
  //     if (getFilingMasterWorkflowComments) {
  // //       console.log("@@Fetch FilingMasters2:");
  //       try {
  //         const commentList = await getFilingMasterWorkflowComments(filingId);
  //         setData(() => commentList);
  // //         console.log("@@Fetch FilingMasters2 comments:", commentList);
  //       } catch (error) {
  // //         console.log("@@Error:", error);
  //       }
  //     }
  //   };

  //   useEffect(() => {
  // //     console.log(`Fetching Commnet for 0:${props.workflow}`);
  //     if (
  //       typeof props.dockAt !== "undefined" &&
  //       typeof props.show !== "undefined"
  //     ) {
  // //       console.log(
  //         `Toogle Drawer UED: DockAt:${props.dockAt}, Show: ${props.show}`
  //       );
  //       // toggleDrawer(props.dockAt, props.show);
  //       setState({ ...state, [props.dockAt]: props.show });
  //     }
  //     setApprovalComment((old) => "");

  //     if (
  //       getFilingMasterWorkflowComments &&
  //       props.workflow &&
  //       props.workflow?.workflowId
  //     ) {
  // //       console.log(`Fetching Commnet for :${props.workflow.workflowId}`);
  //       fetchFilingMasterComments(props.workflow?.workflowId);
  //     }
  //     //eslint-disable-next-line
  //   }, []);
  // const getFilename = function (str: any) {
  //   return str ? str.replace(/^.*[\\\/]/, "") : "";
  // };

  const getFilenameToolip = function (str: any) {
    return str ? str.replace(/^.*[\\\/]/, "") : "";
  };
  const getFilename = function (str: any) {
    const MAX_FILENAME_LENGTH = 20;

    if (str) {
      let filename = str.replace(/^.*[\\\/]/, "");
      if (filename.length > MAX_FILENAME_LENGTH) {
        const halfLength = Math.floor((MAX_FILENAME_LENGTH - 3) / 2);
        const firstHalf = filename.substr(0, halfLength);
        const secondHalf = filename.substr(-halfLength);
        filename = `${firstHalf}...${secondHalf}`;
      }
      return filename;
    } else {
      return "";
    }
  };

  const getUserName = (userId: string) => {
    // console.log("USER ROLES LKP:", userRoles);
    // console.log("USER ROLES LKP2 :", userId);

    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]?.userName
      : "";
    return user;
  };

  const list = (anchor: Anchor) => (
    <Fragment>
      <Dialog
        header="Info"
        visible={showAlert}
        style={{ width: "30vw" }}
        onHide={() => closeAlert()}
        footer={footerContent}
      >
        <p className="m-0">{alertMessage}</p>
      </Dialog>
      <Grid container>
        <Stack
          sx={{
            width: anchor === "top" || anchor === "bottom" ? "auto" : "20vw",
            minWidth: "35vw",
            display: "flex",
            alignContent: "center",
          }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <Card className="tn-comments-drawer-card" sx={{ border: "none", boxShadow: "none" }}>
            <CardContent sx={{ mx: "10px", my: "10px" }}>
              <Stack direction="column" spacing={2}>
                <div>
                  <Stack className="tn-comments-header" direction="row" justifyContent="space-between">
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      sx={{
                        fontWeight: "medium",
                        fontSize: "16px",
                        color: "#424242",
                      }}
                    >
                      COMMENTS
                    </Typography>
                    <IconButton>
                      <CloseIcon onClick={() => handleCancel(anchor)} />
                    </IconButton>
                  </Stack>
                </div>
                <div className="tn-comments-input">
                  <Box>
                    <TrackNowTextField
                      id="notes"
                      name="notes"
                      multiline
                      fullWidth
                      minRows={2}
                      placeholder="Add Comments"
                      value={approvalComment}
                      onChange={(e) => {
                        if (e.target.value.length <= 256) {
                          onCommentChange(e);
                          setRemainingChars(256 - e.target.value.length);
                        }
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontWeight: "small",
                        color: remainingChars === 0 ? "red" : "inherit",
                        display: remainingChars === 256 ? "none" : "block",
                      }}
                    >
                      {remainingChars} Characters are left
                    </Typography>
                  </Box>
                </div>
                <div className="tn-comments-attachments">
                  <MuiButton
                    variant="text"
                    onClick={() => setOpenAttachment(!openAttachment)}
                    disabled={actionType === "Edit"}
                  >
                    <GoogleMaterialIcon name="attach_file" /> Attachment
                  </MuiButton>
                  {actionType === "Edit" && selectedComment
                    && selectedComment.attachmentPath && selectedComment.attachmentPath !== "undefined" && (
                      <MuiButton
                        variant="text"
                        onClick={() =>
                          downloadFile(
                            selectedComment.attachmentPath,
                            selectedComment.attachmentId,
                            selectedComment.commentsId
                          )
                        }
                      >
                        {selectedComment.attachmentPath && <GoogleMaterialIcon name="attach_file" />}
                        <Tooltip
                          title={getFilenameToolip(selectedComment.attachmentPath)}
                        >
                          <ListItemText
                            primary={
                              selectedComment &&
                              selectedComment.attachmentPath &&
                              getFilename(selectedComment.attachmentPath)
                            }
                          />
                        </Tooltip>
                      </MuiButton>
                    )}
                  <Collapse orientation="horizontal" in={openAttachment}>
                    <form
                      method="post"
                      id="uploadForm"
                      onChange={(event) => onFileChange(event)}
                      style={{ margin: "1rem" }}
                      ref={formRef}
                    >
                      <label className="file-upload">
                        <Input
                          type="file"
                          name="file"
                          id="inFile"
                          color="primary"
                        />
                      </label>
                    </form>
                  </Collapse>
                </div>
                <div>
                  <CardActions
                    className="tn-comments-actions"
                    sx={{
                      // mt: "3rem",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    <TrackNowButton
                      variant="tertiary"
                      onClick={() => handleCancel(anchor)}
                    >
                      Cancel
                    </TrackNowButton>
                    {actionType === "Add" ?
                      <TrackNowButton
                        variant="primary"
                        disabled={!approvalComment.trim() || isLoading}
                        onClick={() => handleOk(anchor)}
                      >
                        Add
                      </TrackNowButton>
                      : <TrackNowButton
                        variant="primary"
                        disabled={selectedComment.commentsText.trim() === approvalComment.trim()}
                        onClick={() => editComment()}
                      >
                        Edit
                      </TrackNowButton>}
                  </CardActions>
                </div>
              </Stack>
              <CardContent
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isLoading ? <CircularProgress size={40} /> : null}

                {showError && <Alert severity="error">{alertMessage}</Alert>}
                {showSuccess && (
                  <Alert severity="success">{alertMessage}</Alert>
                )}
              </CardContent>
              <Divider />
              {data && data.length === 0 ? (
                loading ? (
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100px",
                      }}
                    >
                      <CircularProgress size={40} />
                    </div>
                  </CardContent>
                ) : (
                  <CardContent>
                    <Typography variant="body1" color="textSecondary">
                      No comments
                    </Typography>
                  </CardContent>
                )
              ) : (
                <List>
                  {data &&
                    data
                      .slice()
                      //  .reverse()
                      .map((item, index: number) => (
                        <Fragment key={index}>
                          <Stack direction="row" justifyContent="space-between">
                            <ListItem
                              disablePadding
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              {item.updateUser
                                ? getUserName(item.updateUser)
                                : item.createUser && getUserName(item.createUser)}                            </ListItem>
                            <ListItem sx={{ textAlign: "right" }}>
                              <ListItemText
                                secondary={
                                  item &&
                                    item.updateDate
                                    ? toLocalDateTime && `${toLocalDateTime(item.updateDate)}`
                                    : toLocalDateTime && `${toLocalDateTime(item.createDate)}`
                                }
                              />
                            </ListItem>
                          </Stack>
                          <ListItem
                            disablePadding
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

                              <ListItemText
                                sx={{
                                  cursor: "text",
                                  width: "100%",
                                }}
                                primary={
                                  item &&
                                    item.commentsText &&
                                    item.commentsText !== null
                                    ? item.commentsText
                                    : ""
                                }
                              />
                              <IconButton
                                color='primary'
                                disabled={DisableEdit(item)}
                              >
                                <GoogleMaterialIcon 
                                  name="edit" 
                                  onClick={() => handleEditComment(item)}
                                  sx={{ cursor: "pointer" }}
                                />
                              </IconButton>
                              <IconButton
                                color='primary'
                                disabled={DisableEdit(item)}
                              >
                                <GoogleMaterialIcon 
                                  name="delete" 
                                  onClick={() => handleDeleteComment(item)}
                                  sx={{ cursor: "pointer" }}
                                />
                              </IconButton>
                            </div>
                            {item.attachmentPath && item.attachmentPath !== "undefined" && (
                              <TrackNowButton
                                variant="tertiary"
                                onClick={() =>
                                  downloadFile(
                                    item.attachmentPath,
                                    item.attachmentId,
                                    item.commentsId
                                  )
                                }
                              >
                                <GoogleMaterialIcon name="attach_file" />
                                <Tooltip
                                  title={getFilenameToolip(item.attachmentPath)}
                                >
                                  <ListItemText
                                    primary={
                                      item &&
                                      item.attachmentPath &&
                                      getFilename(item.attachmentPath)
                                    }
                                  />
                                </Tooltip>
                              </TrackNowButton>
                            )}
                          </ListItem>
                        </Fragment>
                      ))}
                </List>
              )}
            </CardContent>
          </Card>
        </Stack>
      </Grid>
    </Fragment>
  );

  const DisableEdit = (item: any) => {
    if (roleType?.includes('Admin')) {
      return false
    } else if (authUser?.userId && authUser?.userId === parseInt(item.createUser)) {
      return false
    } else {
      return true
    }
  }
  const handleEditComment = (item: any) => {
    console.log("handleEditComment", item)
    setActionType("Edit")
    setSelectedComment(item)
    setApprovalComment(item.commentsText)
  }
  const editComment = async () => {
    console.log("editComment", selectedComment, props)
    setLoading(true);
    if ((props.workflow && props.workflow.workflowId) || (props.rowData && props.rowData.workflowId)) {
      try {
        const updateDate = new Date();
        let payload = {
          commentsId: selectedComment.commentsId,
          // filingId: props?.workflow?.filingId,
          workflowId: props?.rowData?.workflowId || props?.workflow?.workflowId,
          commentsText: approvalComment,
          updateUser: authUser?.userId + "",
          updateDate

        }
        let res = await axios.put(`${API_BASE_URL}/FilingMaster/UpdateFilingMasterWorkflowComments`, payload)
        console.log("editComment res", res)
        if (res) {
          if (getFilingMasterWorkflowComments) {
            let dataId =
              props.value === "2"
                ? {
                  id: props.rowData?.filingId || props.workflow?.filingId,
                  type: "filing",
                }
                : {
                  id:
                    props.rowData?.workflowId || props.workflow?.workflowId,
                  type: "workflow",
                };
            const _catData = await getFilingMasterWorkflowComments(
              dataId
            );
            setData(() => _catData);
            await fetchCommentsAttachments(_catData);
          }
          setAlertMessage("Successfully updated comment.");
          setShowError(false);
          setShowSuccess(true);
          closeDialog();
          setSelectedComment({})
          setApprovalComment("")
          setActionType("Add")
        }
      } catch (error) {
        console.log("@@Error:", error);
      } finally {
        setLoading(false);
      }
    }
  }

  const handleDeleteComment = (item: any) => {
    console.log("Delete  handleDeleteComment", "item", item);
    setActionType("Add")
    setSelectedComment(item)
    showDialog(
      "Confirmation",
      <Typography>
        Are you sure you want to delete this comment?
      </Typography>,
      "confirm"
    );
  }
  const deleteComments = async () => {
    console.log("Delete  deleteComments", "Workflow", props.workflow);
    setLoading(true);

    try {
      const updateDate = new Date();
      let payload = {
        commentsId: selectedComment.commentsId,
        workflowId: props?.rowData?.workflowId || props?.workflow?.workflowId,
        updateUser: authUser?.userId + "",
        updateDate,
        isDeleted: true,
      }

      let res = await axios.put(`${API_BASE_URL}/FilingMaster/DeleteFilingMasterWorkflowComments`, payload)
      console.log("deleteComments res", res)
      if (res) {
        if (getFilingMasterWorkflowComments) {
          let dataId =
            props.value === "2"
              ? {
                id: props.rowData?.filingId || props.workflow?.filingId,
                type: "filing",
              }
              : {
                id:
                  props.rowData?.workflowId || props.workflow?.workflowId,
                type: "workflow",
              };
          console.log("deleteComments dataId", dataId);

          const _catData = await getFilingMasterWorkflowComments(
            dataId
          );
          setData(() => _catData);
          await fetchCommentsAttachments(_catData);
        }
        props.refreshList()
        setAlertMessage("Successfully deleted comment.");
        setShowError(false);
        setShowSuccess(true);
        closeDialog();
        setSelectedComment({})
      }
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setLoading(false);
    }
  }

  const closeConfirm = () => {
    setApprovalComment("")
  };

  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: deleteComments,
    onClose: closeConfirm,
  });
  const onCommentChange = async (e: React.ChangeEvent<any>) => {
    setApprovalComment((old) => e.target.value);
    if (approvalComment) {
      setShowSuccess(false);
      setShowError(false);
    }
  };

  const handleOk = async (anchor: Anchor) => {
    // navigate("/filing-master-list");
    if (isLoading) {
      return;
    }

    const trimmedComment = approvalComment.trim();
    setShowError(false);
    setIsLoading(true);

    // console.log(`Add Comment:${approvalComment}`);
    if (!trimmedComment) {
      setAlertMessage("Please enter a comment.");
      setShowError(true);
      setIsLoading(false);
      setShowSuccess(false);
    } else {
      setShowSuccess(false);
      setShowError(false);
      // console.log(`Add Comment:${approvalComment}`);
      try {
        const createDate = new Date();

        const payload = {
          commentsText: trimmedComment,
          workflowId: props.rowData?.workflowId || props.workflow?.workflowId,
          createDate,
          createUser: authUser?.userId + "",
          filingId: props.rowData?.filingId || props.workflow?.filingId,
        };
        if (addFilingMasterWorkflowComment) {
          // console.log(`Add Comment payload:${payload}`);
          const res = await addFilingMasterWorkflowComment(payload);
          if (res) {
            console.log(`Comment has been added`, res);
            if (selectedFile) {
              await uploadandUpdateAttachment(res.data.commentsId);
            }
            if (getFilingMasterWorkflowComments) {
              // console.log(
              //   "getFilingMasterWorkflowComments",
              //   props.rowData,
              //   props.workflow
              // );
              let dataId =
                props.value === "2"
                  ? {
                    id: props.rowData?.filingId || props.workflow?.filingId,
                    type: "filing",
                  }
                  : {
                    id:
                      props.rowData?.workflowId || props.workflow?.workflowId,
                    type: "workflow",
                  };
              const _catData = await getFilingMasterWorkflowComments(dataId);
              setData(() => _catData);
              await fetchCommentsAttachments(_catData);
            }
            setState({ ...state, [anchor]: true });
            setAlertMessage("Comment has been added");
            setShowError(false);
            setShowSuccess(true);
            setApprovalComment(() => "");
            setRemainingChars(256);
            setSelectedFile("");
            setOpenAttachment(false);
            formRef.current && formRef.current.reset();
            if (data.length === 0) {
              props.refreshList();
            }
            return;
          }
        }
      } catch (error) {
        console.log(`Error while adding comment`, error);
        setAlertMessage("`Error while adding comment");
        setShowError(true);
        setApprovalComment(() => "");
        setRemainingChars(256);
        props.handleClose();
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCancel = async (anchor: Anchor) => {
    setApprovalComment(() => "");
    setShowSuccess(false);
    setShowError(false);
    setData(() => []);
    setRemainingChars(256);
    setState({ ...state, [anchor]: false });
    props.handleClose();
  };

  const getAttachmentId = async (commentsId: any) => {
    // console.log("getAttachmentIt", props?.workflow);
    // console.log("getAttachmentItRowData", props?.rowData);
    let payload = {
      commentsId: commentsId,
    };

    const res = await axios.post(
      `${API_BASE_URL}/FilingMaster/CreateFilingMasterWorkflowCommentsAttachments`,
      payload
    );
    // console.log("getAttachmentIt res", res.data);
    if (res.data) {
      return res.data.attachmentId;
    }
  };

  const updateFilePath = async (
    commentsId: any,
    attachmentId: any,
    filePath: any
  ) => {
    // console.log("updateFilePath", attachmentId, filePath);
    let payload = {
      attachmentId: attachmentId,
      attachmentPath: decodeURI(filePath),
      createDate: new Date(),
      createUser: authUser?.userId + "",
      commentsId: commentsId,
    };

    const res = await axios.put(
      `${API_BASE_URL}/FilingMaster/UpdateFilingMasterWorkflowCommentsAttachments/${attachmentId}`,
      payload
    );
    // console.log("updateFilePath res", res);
  };

  const onFileUpload = async (commentsId: any) => {
    let attachmentId = await getAttachmentId(commentsId);
    await fileUploadUtil(attachmentId, commentsId);
    return;
  };

  const uploadandUpdateAttachment = async (commentsId: any) => {
    console.log("uploadandUpdateAttachment", commentsId, props, props.rowData?.filingId, props.workflow?.filingId);
    const formData = new FormData();
    formData.append("Files", selectedFile);
    formData.append("commentsId", commentsId);
    formData.append(
      "WorkflowId",
      (props.rowData?.workflowId || props.workflow?.workflowId)?.toString() ??
      ""
    );
    formData.append(
      "filingId",
      (props.rowData?.filingId || props.workflow?.filingId)?.toString() ?? "0"
    );
    formData.append(
      "DraftId",
      (props.rowData?.draftId || props.workflow?.draftId)?.toString() ?? ""
    );
    formData.append("createUser", authUser?.userId + "");
    const res = await axios.post(
      `${API_BASE_URL}/Application/UploadandUpdateAttachment`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("uploadandUpdateAttachment res", res);
    if (res.data) {
    }
  };

  const downloadFile = (
    attachmentPath: any,
    attachmentId: any,
    commentsId: any
  ) => {
    // console.log("Downloading File from:", attachmentId);
    const fileName = getFilename(attachmentPath);
    // console.log("Downloading File:", fileName);
    let filingId = props.rowData?.filingId || props.workflow?.filingId;
    let workflowId = props.rowData?.workflowId || props.workflow?.workflowId;
    let DraftId = props.rowData?.draftId || props.workflow?.draftId;
    axios({
      url: `${API_BASE_URL}/Application/DownloadAttachment?AttachmentId=${attachmentId}&CommentsId=${commentsId}&FilingId=${filingId}&WorkflowId=${workflowId}&DraftId=${DraftId}`,
      method: "POST",
      responseType: "blob", // Important
    }).then((response) => {
      FileDownload(response.data, fileName);
    });
  };

  const fileUploadUtil = async (attachmentId: any, commentsId: any) => {
    // console.log("fileUploadUtil params", attachmentId, commentsId);

    //     -F 'FilingId=' \
    // -F 'CommentId=' \
    // -F 'AttachmentId=' \
    // -F 'DraftId=' \
    // -F 'WorkflowId='
    const formData = new FormData();
    formData.append("Files", selectedFile);
    formData.append("commentId", commentsId);
    formData.append("AttachmentId", attachmentId);
    formData.append(
      "WorkflowId",
      (props.rowData?.workflowId || props.workflow?.workflowId)?.toString() ??
      ""
    );
    formData.append(
      "DraftId",
      (props.rowData?.draftId || props.workflow?.draftId)?.toString() ?? ""
    ); // formData.append("FilingId", attachmentId);

    const res = await axios.post(
      `${API_BASE_URL}/Application/FilingmasterUpload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("fileUploadUtil res", res);

    if (res.data) {
      // console.log("fileUploadUtil res header", res.headers);
      await updateFilePath(commentsId, attachmentId, res.headers["x-file-url"]);
      // setFiles([...files, selectedFile]);
    }
  };

  return (
    <div>
      {/* {(["left", "right", "top", "bottom"] as const).map((anchor) => (
        // <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
      <Dialog
        header="Info"
        visible={showAlert}
        style={{ width: "30vw" }}
        onHide={() => closeAlert()}
        footer={footerContent}
      >
        <p className="m-0">{alertMessage}</p>
      </Dialog>
      <ConfirmDialog />

      {typeof props.dockAt !== "undefined" && (
        <React.Fragment>
          <Drawer
            anchor={props.dockAt}
            open={state[props.dockAt]}
            onClose={toggleDrawer(props.dockAt, false)}
            sx={{ zIndex: "11" }}
          >
            {list(props.dockAt)}
          </Drawer>
        </React.Fragment>
      )}
    </div>
  );
}
